/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../objects/context.js';
import ko from 'knockout';
import $ from 'jquery';
import 'bootstrap';

import 'froala-editor';
import 'knockout-froala';


class jobEditModel {

    constructor(params) {
        // Profile
        this.componentName = "job-edit";
        this.context = context;
        this.id = this.context.util.guid();
        this.visible = ko.observable(true);

        this.viewEditor = ko.observable(true);
        this.viewInlineEditor = ko.observable(false);

        //tabs
        this.generalTabActive = ko.observable("active");
        this.editorTabActive = ko.observable("");
        this.workflowTabActive = ko.observable("");
        this.historyTabActive = ko.observableArray("");

        this.selectedJob = params.jobObj;

        this.editorMessageObj = ko.observable();
        this.workflowMessageObj = ko.observable();
        this.historyMessageObj = ko.observable()

        this.options = {
            // disable wrapping content with paragraphs
            // instead <br> will be used
            enter: $.FroalaEditor.ENTER_DIV,
        
            // we like gray!
            theme: 'gray',
            toolbarButtons: [ 'bold', 'italic', 'underline' ]
          }

        //console.log("jobEditModel");
        //console.log(this.selectedJob);
        //console.log(this.selectedJob.title());

        this.init();

    }

    init(data) {
        //console.log("init");
        //this.getJob();
    }

    inactivateAllTabs()
    {
        this.generalTabActive("");
        this.editorTabActive("");
        this.workflowTabActive("");
        this.historyTabActive("");
    }

    clickTab(item, parent) {

        console.log("job-edit: clickTab");
        console.log(item);
        this.inactivateAllTabs();
        console.log(parent);
        item('active');
        
        //Init Editor
        if(this.editorTabActive() === "active")
        {
            console.log("job-edit: Init Editor:");
            this.editorMessageObj({ event:"getVersion", jobid:this.selectedJob.jobid() });
        }

        //Get Workflows
        if(this.workflowTabActive() === "active")
        {
            parent.getWorkflows(this.context);
        }

        if(this.historyTabActive() === "active")
        {
            this.historyMessageObj({componentName: "job-history", visible: true });
        }
        
    }

    clickCloseEditor(item) {
        console.log("clickCloseEditor");
        console.log(item);
        item.selectedJob.editorVisible(!item.selectedJob.editorVisible());
        item.selectedJob.rowVisible(!item.selectedJob.rowVisible());
    }

    clickViewModelEditor() {

        //$('#editorModal').modal('show');
        this.viewInlineEditor(true);
        this.viewEditor(false);
    }

}

export default { viewModel: jobEditModel, template: require('!raw-loader!./job-edit.html') };


// WEBPACK FOOTER //
// ./src/components/job-edit/job-edit.js